import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface AcceptSelfieUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function acceptSelfieUserAction(userId: string): Promise<ApiResponse<AcceptSelfieUserResponse>> {
  return api.put<ApiResponse<AcceptSelfieUserResponse>>(`/users/${userId}/verify-identification-selfie`)
}
